import { ActionTree, Commit } from 'vuex';
import { WebsiteContentLinkDTO, WebsitePostCategoryDTO} from 'src/services/generated/api.generated.v1';
import { StateInterface } from '../index';
import { ConsumerInformationService, LoggingService } from 'src/services';
import { ConsumerInformationInterface } from './state';
import { FAQ, Podcast, Post } from 'src/components/models';


const actions: ActionTree<ConsumerInformationInterface, StateInterface> = {
    loadContentLinks({ commit }: { commit: Commit }): Promise<void> {
        return new Promise((resolve, reject) => {
            ConsumerInformationService.GetInstance().WebsiteContentLinks()
                .then((dto: WebsiteContentLinkDTO) => {
                    commit('updateContentLinksState', dto);
                    resolve();
                })
                .catch(err => {
                    LoggingService.LogError(err);
                    reject();
                });
        });
    },

    loadPostCategories({ commit }: { commit: Commit }): Promise<void> {
        return new Promise((resolve, reject) => {
            ConsumerInformationService.GetInstance().WebsitePostCategories()
                .then((dto: Array<WebsitePostCategoryDTO>) => {
                    commit('updatePostCategoriesState', dto);
                    resolve();
                })
                .catch(err => {
                    LoggingService.LogError(err);
                    reject();
                });
        });
    },

    loadFAQs({ commit }: { commit: Commit }): Promise<void> {
        return new Promise((resolve, reject) => {
            if(this.state.consumerInformation.contentLinks && this.state.consumerInformation.contentLinks.frequentlyAskedQuestionsLink){
                ConsumerInformationService.GetInstance().FrequentlyAskedQuestions(this.state.consumerInformation.contentLinks?.frequentlyAskedQuestionsLink)
                .then((dto: FAQ | null) => {
                    commit('updateFAQsState', dto);
                    resolve();
                })
                .catch(err => {
                    LoggingService.LogError(err);
                    reject();
                });
            } else {
                LoggingService.LogError('ContentLink State is null');
                resolve();
            }
        });
    },

    loadBlogPosts({ commit }: { commit: Commit }): Promise<void> {
        return new Promise((resolve, reject) => {
            if(this.state.consumerInformation.contentLinks && this.state.consumerInformation.contentLinks.blogPostsLink){
                ConsumerInformationService.GetInstance().BlogPosts(this.state.consumerInformation.contentLinks?.blogPostsLink)
                .then((dto: Array<Post> | null) => {
                    commit('updateBlogPostsState', dto);
                    resolve();
                })
                .catch(err => {
                    LoggingService.LogError(err);
                    reject();
                });
            } else {
                LoggingService.LogError('ContentLink State is null');
                resolve();
            }
  
        });
    },

    loadPodcasts({ commit }: { commit: Commit }): Promise<void> {
        return new Promise((resolve, reject) => {
            if(this.state.consumerInformation.contentLinks && this.state.consumerInformation.contentLinks.podcastLink){
                ConsumerInformationService.GetInstance().Podcasts(this.state.consumerInformation.contentLinks?.podcastLink)
                .then((dto: Array<Podcast> | null) => {
                    commit('updatePodcastsState', dto);
                    resolve();
                })
                .catch(err => {
                    LoggingService.LogError(err);
                    reject();
                });
            } else {
                LoggingService.LogError('ContentLink State is null');
                resolve();
            }
  
        });
    }
};

export default actions;
